import React from 'react';
import Button, { Props as ButtonProps } from '~/components/atom/Button';

/**
 * A specialized button component that renders as an anchor element while maintaining button styling.
 * Used exclusively within StrapiButtons for external link navigation.
 *
 * @internal This component is not intended for use outside of the StrapiButtons context.
 */
const StrapiLinkButton = ({
  url,
  ...rest
}: ButtonProps & { url: string | undefined }) => {
  if (!url) {
    return null;
  }

  const anchorProps = {
    as: 'a',
    href: url,
    target: '_blank',
    rel: 'noopener noreferrer',
    // Center the text vertically
    style: { lineHeight: '0.9' },
  };
  return <Button {...rest} {...anchorProps} />;
};

export default StrapiLinkButton;
